var Backbone = require("../../../libs/backbone/backbone");
var GenericModel = require("../generic.model.ts");

var Model = GenericModel.extend(
{
    urlRoot : '/rest/api/preparations',
    id : null,
    queueId : "",
    firstName : -1,
    lastName : false,
    customerId: null,
    status : false,
    date : null
});

module.exports = Model;